import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {
  image: { maxWidth: '100px', borderRadius: '50%' },
};

const GravatarField = withStyles(styles)(({ classes, record, title }) => {
  const [success, setSuccess] = useState(false);

  const imageUrl = get(record, 'gravatar_image_url');
  const profileUrl = get(record, 'gravatar_profile_url');
  if (!imageUrl) {
    return null;
  }

  return (
    <a
      href={profileUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <img
        title={title}
        alt={title}
        src={imageUrl}
        className={classes.image}
        style={{ display: success ? 'block' : 'none' }}
        onLoad={() => setSuccess(true)}
      />
    </a>
  );
});

GravatarField.propTypes = {
  record: PropTypes.object,
  title: PropTypes.string,
};

GravatarField.defaultProps = {
  title: 'Gravatar',
};

export default GravatarField;
